import { useEffect, useMemo, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import DictionaryRepository from '@/creditflowresearch/infrastructure/repository/DictionaryRepository';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import useCheckboxFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useCheckboxFilter';
import useExcludeToggle from '@/creditflowresearch/ui/common/hooks/sidebar/useExcludeToggle';
import mapToCheckboxOptions from '@/creditflowresearch/application/BondScreener/mapToCheckboxOptions';

const useUseOfProceedsSection = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const repository = getContainer().get(DictionaryRepository);
  const [dictionary, setDictionary] = useState([]);

  const { isExcluded, activeKey, onToggleExclude } = useExcludeToggle({
    includeKey: 'includedUseOfProceedsIds',
    excludeKey: 'excludedUseOfProceedsIds',
    stateKey: 'isUseOfProceedsExcluded',
    useFilterContext: useCorporateBondScreenerSidebarFilterContext,
  });

  useEffect(() => {
    const loadDictionary = async () => {
      setDictionary(await repository.getUopTypes());
    };
    loadDictionary();
  }, []);

  const items = useMemo(
    () => mapToCheckboxOptions(filters?.useOfProceedsIds, dictionary),
    [dictionary, filters?.useOfProceedsIds],
  );

  const checkboxFilter = useCheckboxFilter({ filterKey: activeKey, items });

  return {
    ...checkboxFilter,
    isExcludedEnabled: isExcluded,
    onChangeExclude: onToggleExclude,
  };
};

export default useUseOfProceedsSection;
